module.exports = __webpack_public_path__ + "img/background.9857394d.png";